import { DuplicateFile } from '@dealstack/frontend/shared/components/Documents/types';
import { createBooleanColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/BooleanColumn';
import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const getFileListColumns: ({
	tCapManage,
}: {
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>;
	toggleSelected: (index: number) => void;
}) => ExtendedColumnDef<DuplicateFile>[] = ({ tCapManage }) => [
	createTextColumn({
		headerText: tCapManage('document.duplicate_file_table.columns.name'),
		accessorFn: (row) => row.file.name,
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createBooleanColumn({
		headerText: tCapManage('document.duplicate_file_table.columns.status'),
		accessorKey: 'status',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
];
